import { Button, message, Space } from 'antd';
import React, { startTransition, useEffect, useState } from 'react';
import TableWrap from '../../../../components/TableWrap';
import './index.scss';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../../../store';
import { useNavigate } from 'react-router-dom';
import ModalDelete from '../../../../components/Modal/ModalDelete';
import { deleteBtd, getAllBtds } from '../../../../store/bloodtypedestiny/btdSlice';
import { BtdInterface } from '../../../../interface/bloodtypedestiny';

const BloodTypeDestiny: React.FC = () => {
  const btdSlice = useSelector((state: RootState) => state.btd);
  const { data, loading } = btdSlice;
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState<BtdInterface>();
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  useEffect(() => {
    try {
      dispatch(getAllBtds());
    } catch (error) {
      console.log(`${error}`);
    }
  }, [dispatch]);

  const handleEdit = (record) => {
    startTransition(() => {
      navigate(`/fortune_telling/${record.id}`);
    });
  };
  const showDeleteModal = (record: any) => {
    setSelectedRecord(record as BtdInterface);
    setIsModalOpen(true);
  };

  const handleDelete = async () => {
    if (selectedRecord) {
      try {
        const result = await dispatch(deleteBtd({ id: selectedRecord.id }));
        if (result.meta.requestStatus === 'fulfilled') {
          message.success('削除が成功しました!');
          dispatch(getAllBtds());
        } else {
          message.error('削除に失敗しました。もう一度お試しください。');
        }
      } catch (error) {
        message.error('削除中にエラーが発生しました。');
      } finally {
        setIsModalOpen(false);
      }
    }
  };

  const columns = [
    {
      title: 'タイプ',
      dataIndex: 'type',
      key: 'type',
      render: (type: string) => <span>{type}</span>,
    },
    {
      title: '色名',
      dataIndex: 'colorName',
      key: 'colorName',
      render: (colorName: string) => <span>{colorName}</span>,
    },
    {
      title: '',
      key: 'action',
      align: 'center' as const,
      render: (_: any, record) => (
        <Space size="middle">
          <Button
            type="link"
            icon={
              <img src={`${process.env.PUBLIC_URL}/assets/icons/edit.png`} alt="Edit Logo" className="icon-table" />
            }
            onClick={() => handleEdit(record)}
          />
          <Button
            type="link"
            icon={
              <img src={`${process.env.PUBLIC_URL}/assets/icons/delete.png`} alt="Delete Logo" className="icon-table" />
            }
            danger
            onClick={() => showDeleteModal(record)}
          />
        </Space>
      ),
    },
  ];
  const addBtd = () => {
    startTransition(() => {
      navigate(`/fortune_telling/create`);
    });
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };
  return (
    <div>
      <div className="btd-header">
        <Button className="btn-black" type="primary" onClick={addBtd}>
          新作成
        </Button>
      </div>
      <div className="answer-list-container answer-list">
        <TableWrap
          columns={columns}
          data={data.slice((currentPage - 1) * pageSize, currentPage * pageSize)}
          isLoading={loading}
          total={data.length}
          page={currentPage}
          size={pageSize}
          setPage={(page) => setCurrentPage(page)}
          setSize={(newPageSize) => {
            setPageSize(newPageSize);
            setCurrentPage(1);
          }}
        />
      </div>
      <ModalDelete
        isOpen={isModalOpen}
        onOk={handleDelete}
        onCancel={handleCancel}
        content="「質問セット」を削除してもよろしいですか？"
      />
    </div>
  );
};
export default BloodTypeDestiny;
